import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import LoadingGrid from "../GridView/LoadingGrid";

export default function CategoriesLoading(props) {
  return (
    <div
      style={{
        background: "white",
        paddingTop:
          props.categoriesStyle == "bubbles"
            ? 30
            : props.categoriesStyle == "scroll"
            ? 20
            : 30,
        paddingBottom:
          props.categoriesStyle == "bubbles"
            ? 20
            : props.categoriesStyle == "scroll"
            ? 10
            : 30,
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${7 + 2}, auto)`,
          gridTemplateRows: 1,
          overflow: "auto",
          height: 120,
          paddingRight: 10,
          paddingLeft: 10,
          width: "100%",
          height: "100%",
        }}
        className="disable-scroll-bar w-100"
      >
        {[...Array(10).keys()].map((item) => (
          <div
            style={{
              minWidth: "max-content",
              marginRight: 8,
              marginLeft: 8,
              justifySelf: "center",
              userSelect: "none",
            }}
          >
            <>
              {props.categoriesStyle == "bubbles" && (
                <Skeleton
                  variant="circle"
                  width={70}
                  height={70}
                  style={{ backgroundColor: "#c3c3c3" }}
                />
              )}
              <Skeleton
                variant="text"
                style={{
                  width:
                    props.categoriesStyle == "scroll"
                      ? 70
                      : props.categoriesStyle == "tags"
                      ? 120
                      : props.categoriesStyle == "bubbles"
                      ? 70
                      : 0,
                  height:
                    props.categoriesStyle == "bubbles"
                      ? 20
                      : props.categoriesStyle == "scroll"
                      ? 20
                      : 60,
                  backgroundColor: "#c3c3c3",
                }}
                className="mt-1"
              />
            </>
          </div>
        ))}
      </div>
    </div>
  );
}
